export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0iIzU1NTVGRiIvPgo8cmVjdCB4PSIxMC4zMjkxIiB3aWR0aD0iNS43NzE4MSIgaGVpZ2h0PSIyNSIgcng9IjIuODg1OTEiIGZpbGw9IiM1NTU1RkYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pause.svg
// module id = 240
// module chunks = 0 1 2 3 4 7 17